"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _ContentWithHeaderLayoutTemplate = _interopRequireDefault(require("../../../common/LayoutTemplates/ContentWithHeaderLayoutTemplate/ContentWithHeaderLayoutTemplate"));
var _ThemeSettingsContainer = _interopRequireDefault(require("./ThemeForm/ThemeSettingsContainer"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var profileAndSecurityWidgetClasses = (0, _cssClassesHelper.getBEMClasses)(['profile-and-security-widget']);
var ThemeSettingsCardComponent = function ThemeSettingsCardComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('user'),
    t = _useTranslation.t;
  var themeOptions = props.themeOptions;
  var getLayoutHeader = function getLayoutHeader(header, classes) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes('header')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes('header-text')
    }, header));
  };
  return /*#__PURE__*/_react["default"].createElement(_ContentWithHeaderLayoutTemplate["default"], {
    header: getLayoutHeader(t('Theme'), profileAndSecurityWidgetClasses),
    customClass: "profile-and-security-widget"
  }, /*#__PURE__*/_react["default"].createElement(_ThemeSettingsContainer["default"], {
    themeOptions: themeOptions
  }));
};
var _default = exports["default"] = ThemeSettingsCardComponent;